import React from 'react'

import PopsData from '~/data/sidebar/pops.json'
import { getVisibility } from '../../../utils/helpers'

const regions = ['eu', 'sa', 'na', 'oc', 'mea', 'as', 'planned']

const PopsList = ({ block }) => {
  const showClass = getVisibility(block.block_visibility)

  return (
    <section
      className={`block ${showClass} ${block._template} ${block.css_class_name}`}
    >
      <div className="container">
        <div className="pop-list">
          {regions.map((region) => (
            <PopsCountryList key={region} regionName={region} />
          ))}
        </div>
      </div>
    </section>
  )
}

export const PopsCountryList = ({ regionName }) => {
  return (
    <>
      {PopsData.regions.map((region, index) => {
        if (region.region_class === regionName && region.pops !== undefined) {
          var pops = region.pops.map((pop, index) => {
            if (pop.show_on_list) {
              return (
                <li className="pop-countries__country" key={index}>
                  {pop.flag && (
                    <img src={pop.flag} alt={pop.name} title={pop.name} />
                  )}
                  <span>{pop.name}</span> <PopLabel type={pop.type} />
                </li>
              )
            }

            return null;
          })
          return (
            <ul key={index} className={`pop-countries`}>
              <li className="pop-countries__title">
                <h4>{region.name}</h4>
                <span style={{ background: `${region.list_color}` }}></span>
              </li>
              {pops}
            </ul>
          )
        }

        return null;
      })}
    </>
  )
}

const PopLabel = ({ type }) => {
  switch (type) {
    case 'volume_network':
      return <span className="volume">Volume</span>
    case 'isp_network':
      return <span className="volume">ISP</span>
    default:
      return <></>
  }
}

export default PopsList
